import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import LoginForm from './form/form.page'
import FormHelper from '../../../utils/FormHelper'
import Worker from './worker'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import '../../../assets/styles/form.scss'
import './login.styles.scss'
import iconLogo from '../../../assets/images/logo.png'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

class AuthLogin extends React.Component {

    constructor(props) {
        super(props)
        this.worker = Worker(this)
        this.state = this.worker.getDefaultState()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.worker.isValid() && this.worker.login()
    }

    onRememberMeChange = () => this.setState({
        ...this.state,
        rememberMe: !this.state.rememberMe
    })

    render() {
        return (
            <div className="login">
                {this.state.processing && <Dialog><Loading /></Dialog>}
                <header>
                    <img alt="" src={iconLogo} />
                    <h1>Log in to your account</h1>
                    <p>Welcome back! Please enter your details.</p>
                </header>
                <div className={"flag " + this.state.flag.type}>
                    {this.state.flag.text}
                </div>
                <LoginForm onSubmit={this.onSubmit} onChange={FormHelper(this).onChange} onRememberMeChange={this.onRememberMeChange} {...this.state} />
                <div className="more-actions">
                    <Link to="/auth/forgot">Forgot password?</Link>
                </div>
            </div>
        )
    }
}

export default connect(null)(withRouter(AuthLogin))